var ITEM_INDEX = /^\d+$/;
/**
 * The per-item dirty flags of an array field from react-hook-form's `dirtyFields`.
 * react-hook-form does not always keep them as an array: when the field had no
 * default array (e.g. a publisher loaded without guarantors) a field-array update
 * recomputes the whole field as a single `true`, and nested updates may leave an
 * index-keyed object (RCK-1666).
 *
 * @param flags the value of `dirtyFields.<arrayField>`
 * @return the flags by item index; empty when no item has its own flags
 */
export var dirtyArrayItems = function (flags) {
    if (Array.isArray(flags))
        return flags;
    if (flags === null || typeof flags !== "object")
        return [];
    var items = [];
    Object.entries(flags).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (ITEM_INDEX.test(key))
            items[Number(key)] = value;
    });
    return Array.from(items);
};
